import { createTheme } from '@mui/material/styles';
import colors from '../../layouts/scss/_themes-vars.module.scss';
import componentStyleOverrides from './ComponentStyleOverrides';
import Palette from './Palette';
import Typography from './Typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */
 export const themes = (customization) => {
    const mode = customization.mode;
    const color = colors;

    const themeOption = mode === 'light' ? {
        colors: color,
        heading: color.successDark,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.successLight,
        darkTextPrimary: color.successDark,
        darkTextSecondary: color.successDark,
        textDark: color.successDark,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
        customization
    } : {
        colors: color,
        heading: color.grey50,
        paper: color.darkPaper,
        backgroundDefault: color.darkPaper,
        background: color.grey900,
        darkTextPrimary: color.grey100,
        darkTextSecondary: color.grey300,
        textDark: color.grey50,
        menuSelected: color.darkSecondaryDark,
        menuSelectedBack: color.darkSecondaryLight,
        divider: color.grey600,
        customization
    }

    const themeOptions = {
        direction: 'ltr',
        palette: Palette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        typography: Typography(themeOption)
    };

    const themes = createTheme(themeOptions);
    themes.components = componentStyleOverrides(themeOption);

    return themes;
};

export default themes;
